function Deletion() {
    /// <summary>
    /// This object provides common functions for the Widget.Deletion stystem <br/>
    /// Author: ARF<br />
    /// Date: 28.6.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 28.6.2016                                              *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
Deletion.prototype = new vcTemplate();

Deletion.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, click handler and buttons.
    /// </summary>
  var me = this;
    try {
        if (me.error) { return false; }
        me.showInfo("", "", false);
        me.visual.find("#btnDelete").button().off("click").on("click", function() {
            me.askDel();
        });


        return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};


Deletion.prototype.askDel = function () {
    /// <summary>
    /// This function implements an dialog box for deleting entries. 
    /// </summary>
    var me = this;
    try {


        var dialog = $('<p>' + me.resources.shouldEntryBeDeleted + '</p>').dialog({
            title: me.resources.dialogTitle,
            modal: true,
            dialogClass: 'saveDialog',
            buttons: {
                "Yes": function () {
                    me.del();
                    dialog.dialog('close');
                    return true;
                },
                "Cancel": function () {
                    dialog.dialog('close');
                    return false;
                }
            }
        });
        // ReSharper disable InvalidValue
        $('.saveDialog .ui-button-text:contains(YES)').text(me.resources.yes);
        $('.saveDialog .ui-button-text:contains(CANCEL)').text(me.resources.cancel);
        // ReSharper restore InvalidValue

        return true;
    } catch (ex) { me.writeError('askDel', ex); return false; }
};


Deletion.prototype.del = function () {
    /// <summary>
    /// This function deletes the current user. 
    /// </summary>
    var me = this;
    try {
        if (me.error) { return false; }

        window.VisualCoreService.updateData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, JSON.stringify({'id':me.id}),
            function (result) {
                if (result === false) {
                    me.showMessage(me.resources.err_saveData, true);
                    return false;
                }
                me.visual.find("#divDelEntryNow").hide();
                me.showInfo(me.resources.entryDeleted, "", false);
                me.visual.find('#btnDelete').hide();
                if (me.mq_message_deletion.length > 0) {
                    setTimeout(function() { _VCMQ.produce(me.visual, me.vcgid, me.mq_message_deletion, ''); }, 1000);
                }
                return true;
            });
        return true;
    } catch (ex) {
        me.writeError('send', ex);
        return false;
    }
};

Deletion.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divValidation, .note,.info, #btnDelete').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex);
        return false;
    }
};

